export default __webpack_public_path__ + "static/media/groupMembersRed.3ec539f2.svg";